module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 698422039281,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07649492479508975,
		"cl_weight": 0.27619075514003616,
		"fossil_bank_score": 31.512,
		"fossil_insure_score": 20.5251,
		"wff_mil_weight": 0.04648882140305294,
		"mmc_weight": 0.04648882140305294,
		"cm_weight": 0.007159180625739811,
		"nw_weight": 0.024675735243386003,
		"wff_civ_weight": 0.009340250725890821,
		"gm_weight": 0.001402722216083521,
		"gr_weight": 0.0079375285098073,
		"t_all_weight": 0.015668948447461164,
		"to_weight": 0.006386460898588949,
		"tm_weight": 0.009282487548872212,
		"po_producer_weight": 0.0015341221956292,
		"po_financier_weight": 0.028258144384080433,
		"po_consumer_weight": 0.10659116997567956,
		"pp_weight": 0.1960662887741327,
		"borders_weight": 0.18654937611124073,
		"pp_high_weight": 0.003134866396328383,
		"borders_high_weight": 0.02089214248392855,
		"pff_all_weight": 0.22777075391800103,
		"pff_all_high_weight": 0.02089214248392855,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.593499295436374,
		"gef_score_a": 26.54594747609235,
		"gef_score_b": 9.029832482014012,
		"gef_score_c": 18.373202369725416,
		"gef_score_d": 0.644516967590983,
		"gef_score_a_norm": 66.36486869023088,
		"gef_score_b_norm": 30.099441606713373,
		"gef_score_c_norm": 91.86601184862708,
		"gef_score_d_norm": 6.44516967590983,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 3.64994,
		"trailing_return_m3": 8.12301,
		"trailing_return_m6": 19.94533,
		"trailing_return_y1": 17.56804,
		"trailing_return_y3": 24.90223,
		"trailing_return_y5": 16.43386,
		"trailing_return_y10": 15.26419,
		"trailing_return_y15": 14.59179,
		"trailing_return_y20": 10.92099,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 17068348822,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07539849976588935,
		"cl_weight": 0.2439087764689918,
		"fossil_bank_score": 27.9249,
		"fossil_insure_score": 18.3699,
		"wff_mil_weight": 0.04619375353353584,
		"mmc_weight": 0.04619375353353584,
		"cm_weight": 0.006455911536625511,
		"nw_weight": 0.024481455098840036,
		"wff_civ_weight": 0.008564775909636026,
		"gm_weight": 0.0013184713837114904,
		"gr_weight": 0.007246304525924535,
		"t_all_weight": 0.013801098525761928,
		"to_weight": 0.0057048123553848674,
		"tm_weight": 0.00809628617037706,
		"po_producer_weight": 0.0013424023499724273,
		"po_financier_weight": 0.024932859294708457,
		"po_consumer_weight": 0.09503013908925692,
		"pp_weight": 0.17450986361837312,
		"borders_weight": 0.16660204507276102,
		"pp_high_weight": 0.0030052176633881046,
		"borders_high_weight": 0.01919225772015255,
		"pff_all_weight": 0.2036316068175512,
		"pff_all_high_weight": 0.019202535796720172,
		"pff_all_extreme_weight": 0.00007868306183240315,
		"gef_score_norm": 53.14958203929938,
		"gef_score_a": 25.955333197699385,
		"gef_score_b": 8.52894867396477,
		"gef_score_c": 18.079007410309355,
		"gef_score_d": 0.5862927573136959,
		"gef_score_a_norm": 64.88833299424847,
		"gef_score_b_norm": 28.4298289132159,
		"gef_score_c_norm": 90.39503705154678,
		"gef_score_d_norm": 5.862927573136959,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 3.42751,
		"trailing_return_m3": 8.11548,
		"trailing_return_m6": 19.93302,
		"trailing_return_y1": 17.16822,
		"trailing_return_y3": 23.9086,
		"trailing_return_y5": 15.54627,
		"trailing_return_y10": 14.51897,
		"trailing_return_y15": 14.0358,
		"trailing_return_y20": 10.57716,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 69756059293,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.06757246537787928,
		"cl_weight": 0.0030731360843466947,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.03697988963325598,
		"mmc_weight": 0.03697988963325598,
		"cm_weight": 0.002621767787024516,
		"nw_weight": 0.013198120056127248,
		"wff_civ_weight": 0.0018391125630336136,
		"gm_weight": 0.0006762923319256072,
		"gr_weight": 0.0011628202311080064,
		"t_all_weight": 0.0015106018825135163,
		"to_weight": 0.0010674736781442,
		"tm_weight": 0.0004431282043693163,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0036826714972488643,
		"pp_weight": 0.003985144672255627,
		"borders_weight": 0.010370840484585073,
		"pp_high_weight": 0.002440471688333757,
		"borders_high_weight": 0.003882523995405986,
		"pff_all_weight": 0.012156804017900239,
		"pff_all_high_weight": 0.00412381454479928,
		"pff_all_extreme_weight": 0.0017417694105202786,
		"gef_score_norm": 37.260094889212816,
		"gef_score_a": 18.960383170306184,
		"gef_score_b": 3.3501197652062995,
		"gef_score_c": 14.918128816168142,
		"gef_score_d": 0.03146313753821657,
		"gef_score_a_norm": 47.40095792576546,
		"gef_score_b_norm": 11.167065884020998,
		"gef_score_c_norm": 74.5906440808407,
		"gef_score_d_norm": 0.3146313753821657,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 3.12096,
		"trailing_return_m3": 12.36471,
		"trailing_return_m6": 21.87515,
		"trailing_return_y1": 10.64016,
		"trailing_return_y3": 15.07744,
		"trailing_return_y5": 11.42911,
		"trailing_return_y10": 9.699,
		"trailing_return_y15": 10.3796,
		"trailing_return_y20": 8.11917,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 43557627432,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07525977494835898,
		"cl_weight": 0.25519660007649186,
		"fossil_bank_score": 28.888,
		"fossil_insure_score": 19.2922,
		"wff_mil_weight": 0.047228736625127055,
		"mmc_weight": 0.047228736625127055,
		"cm_weight": 0.006768115039485915,
		"nw_weight": 0.02532349570616261,
		"wff_civ_weight": 0.008878781651709331,
		"gm_weight": 0.001388555761705567,
		"gr_weight": 0.007490225890003765,
		"t_all_weight": 0.014306480370794326,
		"to_weight": 0.0058947555548589685,
		"tm_weight": 0.008411724815935356,
		"po_producer_weight": 0.001395766175373892,
		"po_financier_weight": 0.025791628168523144,
		"po_consumer_weight": 0.09873665156239363,
		"pp_weight": 0.18174519718787807,
		"borders_weight": 0.17336280481691732,
		"pp_high_weight": 0.0030183581986950427,
		"borders_high_weight": 0.020162788057074985,
		"pff_all_weight": 0.21209702063233785,
		"pff_all_high_weight": 0.020162788057074985,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.6234602110337,
		"gef_score_a": 26.156375530023617,
		"gef_score_b": 8.691822910430806,
		"gef_score_c": 18.17521315747448,
		"gef_score_d": 0.6000486130921239,
		"gef_score_a_norm": 65.39093882505904,
		"gef_score_b_norm": 28.972743034769355,
		"gef_score_c_norm": 90.87606578737241,
		"gef_score_d_norm": 6.000486130921239,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 3.45338,
		"trailing_return_m3": 7.9553,
		"trailing_return_m6": 19.89782,
		"trailing_return_y1": 17.57089,
		"trailing_return_y3": 24.47322,
		"trailing_return_y5": 15.82829,
		"trailing_return_y10": 14.88534,
		"trailing_return_y15": 14.3433,
		"trailing_return_y20": 10.78948,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 66877754032,
		"grade_fossil": 5,
		"grade_deforestation": 5,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 5,
		"c2f5coogutweight": 0.10944597977732583,
		"cl_weight": 0.12603077115814362,
		"fossil_bank_score": 32.2362,
		"fossil_insure_score": 21.4317,
		"wff_mil_weight": 0.05972526308628992,
		"mmc_weight": 0.05972526308628992,
		"cm_weight": 0.009934949897538577,
		"nw_weight": 0.029913697415322765,
		"wff_civ_weight": 0.005144044083936605,
		"gm_weight": 0.005144044083936605,
		"gr_weight": 0,
		"t_all_weight": 0.01815473066374588,
		"to_weight": 0.0092020459195899,
		"tm_weight": 0.008952684744155977,
		"po_producer_weight": 0.015020915323223076,
		"po_financier_weight": 0.08903566967735554,
		"po_consumer_weight": 0.09787572665543973,
		"pp_weight": 0.01580828266173648,
		"borders_weight": 0.03199233956385566,
		"pp_high_weight": 0.0007545152972232002,
		"borders_high_weight": 0.00762230841456692,
		"pff_all_weight": 0.03429950870774148,
		"pff_all_high_weight": 0.00837682371179012,
		"pff_all_extreme_weight": 0.0002824352607315975,
		"gef_score_norm": 58.40128685150332,
		"gef_score_a": 25.70764600166721,
		"gef_score_b": 13.87835402656778,
		"gef_score_c": 17.503049548909523,
		"gef_score_d": 1.312237274353425,
		"gef_score_a_norm": 64.26911500416803,
		"gef_score_b_norm": 46.261180088559264,
		"gef_score_c_norm": 87.51524774454762,
		"gef_score_d_norm": 13.12237274353425,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 2.4209,
		"trailing_return_m3": 4.59011,
		"trailing_return_m6": 16.65627,
		"trailing_return_y1": 15.2947,
		"trailing_return_y3": 22.02095,
		"trailing_return_y5": 11.26133,
		"trailing_return_y10": 8.17728,
		"trailing_return_y15": 6.72148,
		"trailing_return_y20": 5.48957,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 20114028191,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09012148442907607,
		"cl_weight": 0.14251572635500043,
		"fossil_bank_score": 7.4117,
		"fossil_insure_score": 6.7426,
		"wff_mil_weight": 0.03356822444257997,
		"mmc_weight": 0.03356822444257997,
		"cm_weight": 0.006348256858887535,
		"nw_weight": 0.016347128484825012,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.0029475094257257217,
		"to_weight": 0.0029475094257257217,
		"tm_weight": 0,
		"po_producer_weight": 0.009791997921156943,
		"po_financier_weight": 0.017269858499547312,
		"po_consumer_weight": 0.008275108448381162,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 48.83948330068329,
		"gef_score_a": 23.693620790899264,
		"gef_score_b": 7.809936530812602,
		"gef_score_c": 16.695591730225274,
		"gef_score_d": 0.6403342487614574,
		"gef_score_a_norm": 59.23405197724816,
		"gef_score_b_norm": 26.033121769375338,
		"gef_score_c_norm": 83.47795865112637,
		"gef_score_d_norm": 6.403342487614575,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 6.89517,
		"trailing_return_m3": 10.57657,
		"trailing_return_m6": 23.05354,
		"trailing_return_y1": 18.9827,
		"trailing_return_y3": 17.82414,
		"trailing_return_y5": 6.34152,
		"trailing_return_y10": 7.34215,
		"trailing_return_y15": 3.35761,
		"trailing_return_y20": 5.35382,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 6863079411,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.11327386964319881,
		"cl_weight": 0.1285103299602669,
		"fossil_bank_score": 32.2768,
		"fossil_insure_score": 16.3597,
		"wff_mil_weight": 0.049837399153473,
		"mmc_weight": 0.049837399153473,
		"cm_weight": 0.00810869908699882,
		"nw_weight": 0.02573268055623343,
		"wff_civ_weight": 0.0031758652343899818,
		"gm_weight": 0.0031758652343899818,
		"gr_weight": 0,
		"t_all_weight": 0.012017902663001963,
		"to_weight": 0.006514923666652769,
		"tm_weight": 0.005502978996349194,
		"po_producer_weight": 0.012209488066026277,
		"po_financier_weight": 0.060155155138127386,
		"po_consumer_weight": 0.0640891446030858,
		"pp_weight": 0.0114286956864258,
		"borders_weight": 0.02061585763298024,
		"pp_high_weight": 0.00045889446225791516,
		"borders_high_weight": 0.0055030827460436854,
		"pff_all_weight": 0.023729323946714582,
		"pff_all_high_weight": 0.0059619772083016,
		"pff_all_extreme_weight": 0.00017088748387494463,
		"gef_score_norm": 57.24285183829424,
		"gef_score_a": 25.585308888272547,
		"gef_score_b": 12.945114635426226,
		"gef_score_c": 17.46830326848347,
		"gef_score_d": 1.2441250461072044,
		"gef_score_a_norm": 63.96327222068137,
		"gef_score_b_norm": 43.15038211808742,
		"gef_score_c_norm": 87.34151634241736,
		"gef_score_d_norm": 12.441250461072045,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 3.8516,
		"trailing_return_m3": 6.74387,
		"trailing_return_m6": 19.26222,
		"trailing_return_y1": 17.14699,
		"trailing_return_y3": 20.91088,
		"trailing_return_y5": 10.17858,
		"trailing_return_y10": 8.12979,
		"trailing_return_y15": 5.91236,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 22842393610,
		"grade_fossil": 4,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 4,
		"c2f5coogutweight": 0.08627272267456765,
		"cl_weight": 0.21870345241190473,
		"fossil_bank_score": 31.4377,
		"fossil_insure_score": 16.1807,
		"wff_mil_weight": 0.04766376339898488,
		"mmc_weight": 0.04766376339898488,
		"cm_weight": 0.007433132052410675,
		"nw_weight": 0.02528452159662169,
		"wff_civ_weight": 0.007187473990084408,
		"gm_weight": 0.0020486922089465653,
		"gr_weight": 0.005138781781137843,
		"t_all_weight": 0.014044033143962045,
		"to_weight": 0.006331677177795355,
		"tm_weight": 0.007712355966166689,
		"po_producer_weight": 0.0052079442882668045,
		"po_financier_weight": 0.039287057375949536,
		"po_consumer_weight": 0.08903833321461484,
		"pp_weight": 0.12271420137210597,
		"borders_weight": 0.12315806356592592,
		"pp_high_weight": 0.002126791660020451,
		"borders_high_weight": 0.015489239901227608,
		"pff_all_weight": 0.14763149305641018,
		"pff_all_high_weight": 0.01565205644901329,
		"pff_all_extreme_weight": 0.00006154410006870937,
		"gef_score_norm": 55.14404781667386,
		"gef_score_a": 26.1685775722786,
		"gef_score_b": 10.078678704227752,
		"gef_score_c": 18.10375450182311,
		"gef_score_d": 0.7930370383332269,
		"gef_score_a_norm": 65.4214439306965,
		"gef_score_b_norm": 33.595595680759175,
		"gef_score_c_norm": 90.51877250911555,
		"gef_score_d_norm": 7.930370383332269,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 3.71215,
		"trailing_return_m3": 7.57461,
		"trailing_return_m6": 19.89682,
		"trailing_return_y1": 17.5895,
		"trailing_return_y3": 23.28105,
		"trailing_return_y5": 13.58479,
		"trailing_return_y10": 12.06859,
		"trailing_return_y15": 10.30251,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-09-30T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 958
// module chunks = 0